// window.baseUrl = 'http://100.25.199.66/';
window.baseUrl = '';
window.hostUrl = 'https://miyaip.com/';
// window.baseUrl = 'http://localhost:8080/';
